import { Row, Col, Icon } from "antd";
import "./index.less";
import isString from "lodash/isString";
import React from "react";
import WeaTools from "../wea-tools";
import middleware from "../../middleware";

class main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showError: false
    };
  }
  componentWillReceiveProps(nextProps) {
    if ("error" in nextProps && nextProps.error) {
      this.setState({
        showError: true
      });
      setTimeout(() => {
        this.setState({
          showError: false
        });
      }, 2000);
      // this.formItemFocus();
    }
  }
  formItemFocus = () => {
    if (!window.ActiveXObject && !("ActiveXObject" in window)) {
      // 非IE下使用scrollIntoView实现滚动定位
      if (!window.doValidateLocaltion) {
        const formItem = ReactDOM.findDOMNode(this.formItem);
        if (formItem && formItem.scrollIntoView) {
          formItem.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
          });
          window.doValidateLocaltion = true;
          setTimeout(() => (window.doValidateLocaltion = false), 2000);
        }
      }
    }
  };
  getErrorStyle = () => {
    const { tipPosition = "top", errorStyle = {} } = this.props;
    let style = { ...errorStyle };
    if (this.errorRef) {
      const height = this.errorRef.clientHeight;
      if (height) {
        const position = -(height + 6);
        style = {
          ...style,
          bottom: tipPosition == "bottom" ? position : "auto",
          top: tipPosition == "bottom" ? "auto" : position
        };
      }
    }
    return style;
  };
  onAdSearch = () => {
    // 支持高级搜索内input框的onEnter触发搜索
    const { onAdSearch } = this.props;
    typeof onAdSearch === "function" && onAdSearch();
  };
  renderChild = children => {
    // 给children绑定onAdSearch事件 - 支持高级搜索内input框的onEnter触发搜索
    if (toString.call(this.props.children) === "[object Array]") {
      return React.Children.map(
        children,
        child =>
          child &&
          (child.type
            ? React.cloneElement(child, { onAdSearch: this.onAdSearch })
            : child)
      );
    } else {
      return (
        children &&
        (children.type
          ? React.cloneElement(children, { onAdSearch: this.onAdSearch })
          : children)
      );
    }
  };
  render() {
    const { showError } = this.state;
    let {
      className = "",
      style,
      label,
      labelCol,
      wrapperCol,
      hideLabel = false,
      viewAttr,
      children,
      colon = true,
      type,
      underline,
      error,
      tipPosition = "top",
      ratio1to2,
      fieldType
    } = this.props;
    const itemWeapperStyle =
      viewAttr && viewAttr != 1
        ? { display: "inline-block", verticalAlign: "top" }
        : { display: "table" };
    if (ratio1to2) {
      labelCol = { span: 8 };
      wrapperCol = { span: 16 };
      return (
        <div
          ref={ref => (this.formItem = ref)}
          className={`${className} wea-form-item clearfix wea-error ${
            underline ? "underline" : "setLineHeight"
          } ${error && showError ? "has-error" : ""}`}
          style={style}
        >
          <Row>
            {fieldType !== WeaTools.types.DESCRIPTION && (
              <Col {...labelCol} style={{ position: "static" }}>
                {!hideLabel && labelCol && (
                  <div
                    title={isString(label) ? label : ""}
                    className={`wea-form-item-label text-elli ${
                      type == "card" ? "card" : ""
                    }
                ${colon ? "colon" : ""}`}
                    style={{ width: `${(labelCol.span / 24) * 100}%` }}
                  >
                    {label}
                  </div>
                )}
              </Col>
            )}
            <Col {...wrapperCol}>
              <div className="wea-form-item-wrapper" style={itemWeapperStyle}>
                {/* {this.renderChild(children)} */}
                {children}
                {error && showError && (
                  <span
                    ref={ref => (this.errorRef = ref)}
                    className={`error-tip ${
                      tipPosition == "bottom" ? "tip-bottom" : ""
                    }`}
                    style={this.getErrorStyle()}
                    // style={errorStyle}
                  >
                    <Icon type="exclamation-circle" />
                    <span className="tip-msg">{error}</span>
                  </span>
                )}
              </div>
            </Col>
          </Row>
        </div>
      );
    }
    return (
      <Row
        ref={ref => (this.formItem = ref)}
        className={`${className} wea-form-item clearfix wea-error ${
          underline ? "underline" : "setLineHeight"
        } ${error && showError ? "has-error" : ""}`}
        style={style}
      >
        {fieldType !== WeaTools.types.DESCRIPTION && (
          <Col {...labelCol} style={{ position: "static" }}>
            {!hideLabel && labelCol && (
              <div
                title={isString(label) ? label : ""}
                className={`wea-form-item-label text-elli ${
                  type == "card" ? "card" : ""
                }
                ${colon ? "colon" : ""}`}
                style={{ width: `${(labelCol.span / 24) * 100}%` }}
              >
                {label}
              </div>
            )}
          </Col>
        )}
        <Col {...wrapperCol}>
          <div className="wea-form-item-wrapper" style={itemWeapperStyle}>
            {/* {this.renderChild(children)} */}
            {children}
            {error && showError && (
              <span
                ref={ref => (this.errorRef = ref)}
                className={`error-tip ${
                  tipPosition == "bottom" ? "tip-bottom" : ""
                }`}
                style={this.getErrorStyle()}
                // style={errorStyle}
              >
                <Icon type="exclamation-circle" />
                <span
                  className="tip-msg"
                  dangerouslySetInnerHTML={{ __html: error }}
                ></span>
              </span>
            )}
          </div>
        </Col>
      </Row>
    );
  }
}

const Com = middleware(main, "WeaFormItem");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-form-item/index.js